module.exports = __webpack_public_path__ + "img/FintiLogo.b3d096e4.svg";